import React, { createContext, useContext, useMemo } from 'react';

export const AppContext = createContext(null);

export const useAppContext = () => {
    const context = useContext(AppContext);
    if (!context) {
        throw new Error('useAppContext must be used within an AppProvider');
    }
    return context;
};

export const AppProvider = ({ 
    children, 
    userScopedFetch, 
    spaceScopedFetch,
    accounts, 
    identity, 
    activeAccounts, 
    categoriesQuery,
    connectionsQuery,
    setIsSidenavOpen, 
    setShowAddAccountModal,
    spaces,
    currentSpace,
    setCurrentSpaceUri,
    agentFilter,
    setAgentFilter
}) => {
    const appContextValue = useMemo(() => ({
        userScopedFetch,       // For user-scoped endpoints (identity, providers, connections, spaces)
        spaceScopedFetch,  // For space-scoped endpoints (accounts, categories, rules, transactions)
        accounts,
        identity,
        activeAccounts,
        categoriesQuery,
        connectionsQuery,
        setIsSidenavOpen,
        onAddAccount: () => setShowAddAccountModal(true),
        spaces,
        currentSpace,
        setCurrentSpaceUri,
        agentFilter,
        setAgentFilter,
    }), [
        userScopedFetch,
        spaceScopedFetch,
        accounts,
        identity,
        activeAccounts,
        categoriesQuery,
        connectionsQuery,
        setIsSidenavOpen,
        setShowAddAccountModal,
        spaces,
        currentSpace,
        setCurrentSpaceUri,
        agentFilter,
        setAgentFilter
    ]);

    return (
        <AppContext.Provider value={appContextValue}>
            {children}
        </AppContext.Provider>
    );
};
